module.exports = __webpack_public_path__ + "static/img/local-content-img.2f397b5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/local/local-content-img.jpeg
// module id = LEN5
// module chunks = 1